import { productAlertTargetAppGroup } from "./constants";
import type { ProductAlertListResultItem, WorkspaceProductAlert } from "./types";

/** Whether a listed alert is a workspace alert: it targets the app group and carries an alert type. */
export const isWorkspaceProductAlert = (alert: ProductAlertListResultItem): alert is WorkspaceProductAlert => {
  return alert.target === productAlertTargetAppGroup && Boolean(alert.alert_type);
};
